/** Parse optional persisted JSON without allowing malformed storage to break a page. */
export function readStoredJson<T>(
  storage: Pick<Storage, "getItem">,
  key: string,
  isValid: (value: unknown) => value is T,
): T | null {
  try {
    const raw = storage.getItem(key);
    if (raw === null) return null;
    const value: unknown = JSON.parse(raw);
    return isValid(value) ? value : null;
  } catch {
    return null;
  }
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}
